<template>
    <div>
        <van-nav-bar :title="activityTheme"/>
        <div>
            <van-swipe :autoplay="3000" :height="160">
                <van-swipe-item v-for="(image, index) in imageList" :key="index">
                    <img :src="imgUrl+image" />
                </van-swipe-item>
            </van-swipe>
            <van-cell-group>
                <van-cell size="large" title="活动日期" :label="startTime" readonly/>
                <van-cell size="large" title="活动地点" :label="activityPlace" readonly/>
                <van-cell size="large" title="活动简介" :label="activityFlow"  rows="3" autosize type="textarea" readonly/>
            </van-cell-group>
        </div>
        <div class="bottom-div">
            <van-button type="danger" :disabled="disabled" size="large" width="100%" @click="activitySign()">{{message}}</van-button>
        </div>
    </div>
</template>

<script>
    import {CellGroup,Button,Field,NavBar,Cell,Swipe, SwipeItem } from 'vant';
    import moment from "moment";
    import {getKey} from "../utils/url";
    import activityService from "../service/activityService";
    import {API_URL} from "../common/config";

    export default {
        data: function () {
            return {
                activityTheme:'',
                activityPlace:'',
                activityFlow:'',
                activityId:'',
                advisorId:'',
                cropId:'',
                disabled:false,
                message:"我要报名",
                imageList:[],
                startTime:''
            }
        },
        components: {
            [Cell.name]: Cell,
            [Swipe.name]: Swipe,
            [Field.name]: Field,
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [SwipeItem.name]: SwipeItem,
            [CellGroup.name]: CellGroup
        },
        computed: {
            imgUrl() {
                return API_URL + "/crm/activity/showActivityImage?cropId="+this.cropId+"&activityId="+this.activityId+"&id=";
            }
        },
        created: async function () {
            this.activityId = getKey("activityId");
            this.cropId = getKey("cropId");
            this.advisorId = getKey("advisorId");
            let resp = await activityService.getActivityById(this.activityId,this.cropId);
            if (resp.data.Status === "1"){
                let data = resp.data.Data;
                this.activityTheme =data.theme;
                this.activityPlace = data.place;
                this.activityFlow = data.flow;
                this.startTime = moment(data.time).format('YYYY-MM-DD');
                this.imageList =data.images.split(",");
                if (Date.parse(data.time) < new Date()) {
                    this.disabled = true;
                    this.message = "活动已开始";
                }
            }
        },
        methods:{
            activitySign() {
                this.$router.push("/signUp?startTime="+this.startTime+"&activityTheme="+
                    this.activityTheme+"&cropId="+this.cropId+"&advisorId="+this.advisorId+"&activityId="+this.activityId)
            }
        }
    };

</script>
<style scoped>
    .van-cell-group{
        padding: 10px;
        margin-bottom: 10px;
    }
    .bottom-div{
        position: absolute;
        width: 100%;
        bottom: 0;
    }
    .van-button--danger{
        color: #fff;
        background-color: #f44;
        border: 1px solid #f44;
    }
    img{
        height: 10.63rem;
        margin: auto;
    }
    .van-cell__label {
        color: #323233;
        font-size: 15px;
        margin-top: 3px;
        line-height: 24px;
        white-space: pre-wrap;
    }
    .van-cell{
        color: #f44
    }
    .van-swipe-item{
       text-align: center;
    }
    .van-ellipsis{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 600;
    }
</style>
